import AuthorPage from '../../../components/AuthorPage/AuthorPage';
import { buildPrimaryAuthorPage } from '../../../util/buildPrimaryAuthorPage';
import { Layout } from '../[[...slug]]';

const { getStaticProps, getStaticPaths, Page } = await buildPrimaryAuthorPage({
    site: 'NEWS',
    LayoutComponent: Layout,
    ContentComponent: AuthorPage,
    menuPropName: 'submenu',
    hasStickyNav: true,
});

export { getStaticProps, getStaticPaths };

export default Page;
